export { CustomOtpInput } from './component';
